import { BASE_NAMES } from "@/lib/jobs";

const AHEAD = { home: ["first", "second", "third", "home"], first: ["second", "third", "home"], second: ["third", "home"], third: ["home"] };
const SOURCES = [["home", 0], ["first", 1], ["second", 2], ["third", 4]];

export const RunnerEditor = ({ runners, paths, onChange }) => {
  const list = SOURCES.filter(([b, bit]) => b === "home" || runners & bit).map(([b]) => b);
  const setDst = (src, dst) => onChange([...paths.filter((p) => p.src !== src), ...(dst ? [{ src, dst }] : [])]);
  return (
    <div className="space-y-1.5" data-testid="runner-editor">
      <span className="ctl-label">Runners</span>
      {list.map((src) => (
        <div key={src} className="flex items-center gap-2">
          <span className="w-20 text-sm font-bold">{src === "home" ? "Batter" : `On ${BASE_NAMES[src]}`}</span>
          <select data-testid={`runner-dst-${src}`} className="field-input flex-1" value={paths.find((p) => p.src === src)?.dst || ""}
            onChange={(e) => setDst(src, e.target.value)}>
            <option value="">{src === "home" ? "Out / doesn't run" : "Holds"}</option>
            {AHEAD[src].map((b) => <option key={b} value={b}>{b === "home" ? "Scores" : `Runs to ${BASE_NAMES[b]}`}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
};
